<template>
  <div>
    <v-row class="mt-n4">
      <v-col cols="12">
        <v-skeleton-loader
          :loading="loading"
          class="actions__left"
          type="list-item-avatar-two-line"
        >
          <span v-if="isNew">
            <div class="headline mt-2">Konseling Baru</div>
            <div class="subtitle text--secondary">
              Mengajukan sebagai
              <b>{{user.name}}</b>
            </div>
            <span v-if="$vuetify.breakpoint.xsOnly"></span>
          </span>
          <span v-else>
            <div class="headline mt-2">{{discussion.Title}}</div>
            <div class="subtitle text--secondary">
              Dibuat oleh
              <b>{{discussion.CreatedByUser.Name}}</b>
              &mdash;{{discussion.CreatedDate | dateRelative }}
            </div>
          </span>
        </v-skeleton-loader>
        <v-divider class="mt-3" />
      </v-col>
    </v-row>

    <v-row class="mt-n3">
      <v-col cols="12" md="9">
        <v-skeleton-loader
          :loading="loading"
          class="actions__left"
          type="list-item-avatar-three-line,list-item-avatar-two-line,list-item-avatar-two-line, list-item-two-line, actions"
        >
          <v-timeline align-top dense class="mt-n3">
            <span v-if="!isNew">
              <v-timeline-item
                icon="mdi-message-reply"
                right
                fill-dot
                :small="false"
                color="primary"
              >
                <v-card class="elevation-2">
                  <v-card-text>{{discussion.Comment}}</v-card-text>
                </v-card>
              </v-timeline-item>
              <template v-for="log in discussion.Logs">
                <v-timeline-item
                  :key="log.ID"
                  right
                  fill-dot
                  small
                  v-if="$acl.check('isSuperAdmin') || log.Type == 'reply'"
                  :color="log.Type == 'reply'?(log.CreatedBy == discussion.CreatedBy?'primary':'info'):'secondary'"
                >
                  <v-card class="elevation-2" v-if="log.Type=='reply'">
                    <v-card-text>
                      <div class="mb-3">{{replies[log.IDDiscussionReply].Comment}}</div>
                      <i class="text--secondary caption">
                        <strong>{{replies[log.IDDiscussionReply].CreatedByUser.Name}}</strong>
                        &mdash;
                        {{$format.relativeUpdatedDate(replies[log.IDDiscussionReply])}}
                      </i>
                    </v-card-text>
                  </v-card>
                  <div class="body-2" v-else>
                    <b>{{log.CreatedByUser.Name}}</b>
                    <span v-if="log.Type=='label'">
                      memasang
                      label
                      <v-chip
                        label
                        small
                        v-for="label in log.Labels"
                        :key="label.ID"
                        class="ml-2"
                        :color="label.Color"
                        v-text="label.Description"
                        dark
                      ></v-chip>
                    </span>
                    <span v-else-if="log.Type=='category'">
                      memasang
                      kategori
                      <b>{{log.Category.Name}}</b>
                    </span>
                    <span v-else-if="log.Type=='review'">
                      memberi
                      ulasan
                      <b>{{log.Review}} &#9733;</b>.
                    </span>
                    <span v-else-if="log.Type=='assign'">
                      mendelegasikan kepada
                      <b>{{(log.AssignedUser)?log.AssignedUser.Name:'-'}}</b>
                    </span>
                    <span v-else-if="log.Type=='escalated'">
                      mengeskalasi konseling kepada
                      <b>{{log.AssignedUser.Name}}</b>
                    </span>
                    <span v-else-if="log.Type=='status'">
                      mengubah status menjadi
                      <b>
                        <v-icon
                          :color="parseStatus(log.Status,'color')"
                          v-text="parseStatus(log.Status,'icon')"
                        ></v-icon>
                        {{parseStatus(log.Status)}}
                      </b>
                    </span>
                    &mdash;
                    <span
                      class="caption text--secondary"
                    >{{log.CreatedDate | dateRelative}}</span>
                  </div>
                </v-timeline-item>
              </template>
            </span>
            <v-timeline-item
              icon="mdi-message-text"
              right
              fill-dot
              color="primary"
              v-if="!terkunci"
            >
              <ValidateAll ref="discussion">
                <v-form>
                  <v-card class="elevation-2">
                    <v-card-title class="headline" v-if="isNew">
                      <Validate
                        class="w-100"
                        :name="isNew?'Judul pertanyaan':'Judul balasan'"
                        rules="required"
                        #default="{ errors }"
                      >
                        <v-text-field
                          v-model="form.Title"
                          label="Judul"
                          hide-details="auto"
                          :error-messages="errors"
                          :placeholder="isNew?'Judul pertanyaan':'Judul balasan'"
                          outline
                        ></v-text-field>
                      </Validate>
                    </v-card-title>
                    <v-card-text>
                      <Validate
                        :name="isNew?'Pertanyaan':'Balasan'"
                        rules="fully_required"
                        #default="{ errors }"
                      >
                        <v-textarea
                          v-model="form.Comment"
                          outline
                          rows="3"
                          auto-grow
                          :error-messages="errors"
                          hide-details="auto"
                          :label="isNew?'Pertanyaan':'Balasan'"
                          :placeholder="isNew?'Silahkan masukkan isi pertanyaan Anda':'Silahkan masukkan balasan Anda'"
                        ></v-textarea>
                      </Validate>
                    </v-card-text>
                    <v-card-actions class="pb-4">
                      <!-- <v-btn @click="reset" v-if="!$vuetify.breakpoint.xsOnly">Ulang</v-btn>
                      <v-spacer v-if="!$vuetify.breakpoint.xsOnly" />-->
                      <v-btn color="primary" @click="send()" :loading="saving">
                        Kirim {{isNew?'Pertanyaan':'Balasan'}}
                        <v-icon right>mdi-send</v-icon>
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-form>
              </ValidateAll>
            </v-timeline-item>
            <v-timeline-item icon="mdi-star" right fill-dot color="primary" v-if="bukaFormRating">
              <ValidateAll ref="reviews">
                <v-form>
                  <v-card class="elevation-2">
                    <v-card-title class="headline">
                      <v-rating v-model.number="ulasan.Review" half-increments label="Rating" large></v-rating>
                    </v-card-title>
                    <v-card-text>
                      <Validate name="Ulasan" rules="required" #default="{ errors }">
                        <v-textarea
                          v-model="ulasan.ReviewComment"
                          outline
                          rows="3"
                          auto-grow
                          :error-messages="errors"
                          hide-details="auto"
                          label="Ulasan"
                          placeholder="Silahkan masukkan ulasan Anda"
                        ></v-textarea>
                      </Validate>
                    </v-card-text>
                    <v-card-actions class="pb-4">
                      <!-- <v-btn @click="reset" v-if="!$vuetify.breakpoint.xsOnly">Ulang</v-btn>
                      <v-spacer v-if="!$vuetify.breakpoint.xsOnly" />-->
                      <v-btn color="primary" @click="send()" :loading="saving">
                        Kirim
                        <v-icon right>mdi-send</v-icon>
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-form>
              </ValidateAll>
            </v-timeline-item>
          </v-timeline>
        </v-skeleton-loader>
      </v-col>
      <v-divider vertical class="hidden-xs-only" />
      <v-col cols="3" v-if="!$vuetify.breakpoint.xsOnly" class="mr-n1">
        <v-row>
          <v-col cols="12" v-if="!isNew">
            <v-skeleton-loader :loading="loading" type="list-item-two-line">
              <v-card>
                <v-card-subtitle class="pb-0 d-flex">
                  <div class="overline">
                    <v-icon small left class="mt-n1">mdi-label-variant</v-icon>Status
                  </div>
                  <v-btn
                    icon
                    color="primary"
                    v-if="!(isStatusEmpty || isEditingStatus) && !terkunci && $acl.check('isSpitda')"
                    @click="isEditingStatus = true"
                  >
                    <v-icon small>mdi-cog</v-icon>
                  </v-btn>
                </v-card-subtitle>

                <v-list-item two-line>
                  <v-select
                    v-if="isEditingStatus"
                    class="mb-1 mt-1"
                    v-model="form.Status"
                    :items="discussionStatusList"
                    name="Status"
                    placeholder="Pilih Status"
                    item-text="text"
                    item-value="value"
                    dense
                  >
                    <!-- button slot -->
                    <template v-slot:append-outer>
                      <v-btn
                        icon
                        :loading="setStatusLoading"
                        :disabled="isStatusEmpty"
                        :color="isStatusEmpty ? 'disabled' : 'success'"
                        @click="setStatus"
                      >
                        <v-icon>mdi-check-outline</v-icon>
                      </v-btn>
                    </template>
                    <!-- selected slot -->
                    <template v-slot:selection="data">
                      <v-list-item-title>{{data.item.text}}</v-list-item-title>
                    </template>
                    <!-- list item slot -->
                    <template v-slot:item="data">
                      <template v-if="typeof data.item !== 'object'">
                        <v-list-item-content v-text="data.item"></v-list-item-content>
                      </template>
                      <template v-else>
                        <v-list-item-content>{{data.item.text}}</v-list-item-content>
                      </template>
                    </template>
                  </v-select>

                  <!-- display -->
                  <v-list-item-avatar v-if="!isStatusEmpty && !isEditingStatus">
                    <v-icon
                      large
                      :color="parseStatus(form.Status,'color')"
                      v-text="parseStatus(form.Status,'icon')"
                    ></v-icon>
                  </v-list-item-avatar>

                  <v-list-item-content class="ml-n2" v-if="!isStatusEmpty && !isEditingStatus">
                    <v-list-item-title v-text="parseStatus(form.Status)"></v-list-item-title>
                    <v-list-item-subtitle class="text--disabled">
                      <span v-if="form.Status == 'open'">{{form.OpenedDate | dateTime}}</span>
                      <span v-else-if="form.Status == 'reopen'">{{form.ReOpenedDate | dateTime}}</span>
                      <span v-else-if="form.Status == 'closed'">{{form.ClosedDate | dateTime}}</span>
                      <span v-else-if="form.Status == 'verified'">{{form.VerifiedDate | dateTime}}</span>
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-card>
            </v-skeleton-loader>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-skeleton-loader :loading="loading" type="list-item-two-line">
              <v-card>
                <v-card-subtitle class="pb-0 d-flex">
                  <div class="overline">
                    <v-icon small left class="mt-n1">mdi-shape</v-icon>Kategori
                  </div>
                  <v-btn
                    icon
                    color="primary"
                    v-if="!(isKategoriEmpty || isEditingKategori)&& !terkunci"
                    @click="isEditingKategori = true"
                  >
                    <v-icon small>mdi-cog</v-icon>
                  </v-btn>
                </v-card-subtitle>
                <v-list-item two-line v-if="isEditingKategori">
                  <ValidateAll ref="kategori">
                    <v-form>
                      <Validate name="Kategori" rules="fully_required" #default="{ errors }">
                        <v-autocomplete
                          class="mb-1 mt-1"
                          v-model="form.Category"
                          :loading="list.isKategoriLoading"
                          :items="list.kategori.data"
                          :error-messages="errors"
                          name="Kategori"
                          placeholder="Pilih Kategori"
                          item-text="Name"
                          item-value="ID"
                          hide-no-data
                          return-object
                          dense
                        >
                          <!-- button slot -->
                          <template v-slot:append-outer>
                            <v-btn
                              icon
                              :loading="setKategoriLoading"
                              :disabled="isKategoriEmpty"
                              :color="isKategoriEmpty ? 'disabled' : 'success'"
                              @click="setKategori"
                            >
                              <v-icon>mdi-check-outline</v-icon>
                            </v-btn>
                          </template>
                          <!-- selected slot -->
                          <template v-slot:selection="data">
                            <v-list-item-title>{{data.item.Name}}</v-list-item-title>
                          </template>
                          <!-- list item slot -->
                          <template v-slot:item="data">
                            <template v-if="typeof data.item !== 'object'">
                              <v-list-item-content v-text="data.item"></v-list-item-content>
                            </template>
                            <template v-else>
                              <v-list-item-content class="py-0">
                                <v-list-item-title>{{data.item.Name}}</v-list-item-title>
                                <!-- <v-list-item-subtitle v-if="data.item.Description">{{data.item.Description}}</v-list-item-subtitle> -->
                              </v-list-item-content>
                            </template>
                          </template>
                        </v-autocomplete>
                      </Validate>
                    </v-form>
                  </ValidateAll>
                </v-list-item>
                <v-list-item two-line v-if="!isKategoriEmpty && !isEditingKategori">
                  <v-list-item-content>
                    <v-list-item-title class="title">
                      <!-- <v-icon :color="form.Category.Color">mdi-checkbox-blank-circle</v-icon> -->
                      {{form.Category.Name}}
                    </v-list-item-title>
                    <v-list-item-subtitle>
                      <span class="text--primary">{{form.Category.Description}}</span>
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-card>
            </v-skeleton-loader>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-skeleton-loader :loading="loading" type="list-item-two-line">
              <v-card>
                <v-card-subtitle class="pb-0 d-flex">
                  <div class="overline">
                    <v-icon small left class="mt-n1">mdi-label-outline</v-icon>Label
                  </div>
                  <v-btn
                    icon
                    color="primary"
                    v-if="!(isLabelEmpty || isEditingLabel) && !terkunci"
                    @click="isEditingLabel = true"
                  >
                    <v-icon small>mdi-cog</v-icon>
                  </v-btn>
                </v-card-subtitle>

                <v-list-item two-line v-if="isEditingLabel">
                  <v-autocomplete
                    class="mb-1 mt-1"
                    v-model="form.Labels"
                    :loading="list.isLabelLoading"
                    :items="list.label.data"
                    name="Label"
                    placeholder="Pilih Label"
                    item-text="Name"
                    item-value="ID"
                    hide-no-data
                    hide-selected
                    return-object
                    deletable-chips
                    multiple
                  >
                    <!-- button slot -->
                    <template v-slot:append-outer>
                      <v-btn
                        icon
                        :loading="setLabelLoading"
                        :disabled="isLabelEmpty"
                        :color="isLabelEmpty ? 'disabled' : 'success'"
                        @click="setLabel"
                      >
                        <v-icon>mdi-check-outline</v-icon>
                      </v-btn>
                    </template>
                    <!-- selected slot -->
                    <template v-slot:selection="data">
                      <v-chip
                        label
                        close
                        @click="data.select"
                        @click:close="removeLabel(data.item)"
                        :color="data.item.Color"
                        dark
                      >{{data.item.Name}}</v-chip>
                    </template>
                    <!-- list item slot -->
                    <template v-slot:item="data">
                      <template v-if="typeof data.item !== 'object'">
                        <v-list-item-content v-text="data.item"></v-list-item-content>
                      </template>
                      <template v-else>
                        <v-list-item-content class="py-0">
                          <v-list-item-title>
                            <v-chip
                              label
                              class="w-100"
                              :color="data.item.Color"
                              dark
                            >{{data.item.Name}}</v-chip>
                          </v-list-item-title>
                          <!-- <v-list-item-subtitle v-if="data.item.Description">{{data.item.Description}}</v-list-item-subtitle> -->
                        </v-list-item-content>
                      </template>
                    </template>
                  </v-autocomplete>
                </v-list-item>

                <v-list-item two-line v-if="!isLabelEmpty && !isEditingLabel">
                  <v-list-item-content>
                    <span v-if="form.Labels && form.Labels.length > 0">
                      <v-chip
                        v-for="(label) in form.Labels"
                        label
                        class="ma-1"
                        :key="label.ID"
                        :color="label.Color"
                        dark
                      >{{label.Name}}</v-chip>
                    </span>
                    <span v-else class="text-center w-100 text--secondary">Label konseling kosong</span>
                  </v-list-item-content>
                </v-list-item>
              </v-card>
            </v-skeleton-loader>
          </v-col>
        </v-row>
        <v-row v-if="!isNew && $acl.check('isSpitda')">
          <v-col cols="12">
            <v-skeleton-loader :loading="loading" type="list-item-two-line">
              <v-card>
                <v-card-subtitle class="pb-0 d-flex">
                  <div class="overline">
                    <v-icon small left class="mt-n1">mdi-label-outline</v-icon>
                    {{$acl.check('isKepalaSpitda') ? 'Delegasi Tugas':'Eskalasi Tugas'}}
                  </div>
                  <v-btn
                    icon
                    color="primary"
                    v-if="!(isDelegasiEmpty || isEditingDelegasi) && !terkunci && $acl.check('isSpitda')"
                    @click="isEditingDelegasi = true"
                  >
                    <v-icon small>mdi-cog</v-icon>
                  </v-btn>
                </v-card-subtitle>

                <v-list-item two-line v-if="isEditingDelegasi">
                  <v-autocomplete
                    class="mb-1 mt-1"
                    v-model="form.AssignedUser"
                    :loading="list.isDelegasiLoading"
                    :items="userList"
                    name="Pengguna"
                    placeholder="Pilih Pengguna"
                    item-text="Name"
                    item-value="ID"
                    hide-no-data
                    dense
                    return-object
                  >
                    <!-- button slot -->
                    <template v-slot:append-outer>
                      <v-btn
                        icon
                        :loading="setDelegasiLoading"
                        :disabled="isDelegasiEmpty"
                        :color="isDelegasiEmpty ? 'disabled' : 'success'"
                        @click="setDelegasi"
                      >
                        <v-icon>mdi-check-outline</v-icon>
                      </v-btn>
                    </template>
                    <!-- selected slot -->
                    <template v-slot:selection="data">
                      {{data.item.Name}} &mdash;
                      <span
                        class="text--secondary"
                      >{{data.item.Group.Name}}</span>
                    </template>
                    <!-- list item slot -->
                    <template v-slot:item="data">
                      <template v-if="typeof data.item !== 'object'">
                        <v-list-item-content v-text="data.item"></v-list-item-content>
                      </template>
                      <template v-else>
                        <v-list-item-content class="py-0">
                          <v-list-item-title>
                            {{data.item.Name}} &mdash;
                            <span
                              class="text--secondary"
                            >{{data.item.Group.Name}}</span>
                          </v-list-item-title>
                          <!-- <v-list-item-subtitle v-if="data.item.Description">{{data.item.Description}}</v-list-item-subtitle> -->
                        </v-list-item-content>
                      </template>
                    </template>
                  </v-autocomplete>
                </v-list-item>

                <v-list-item two-line v-if="!isDelegasiEmpty && !isEditingDelegasi">
                  <v-list-item-content>
                    <span v-if="!$util.isEmpty(form.AssignedUser)">{{form.AssignedUser.Name}}</span>
                    <span v-else class="text-center w-100 text--secondary">Delegasi kosong</span>
                  </v-list-item-content>
                </v-list-item>
              </v-card>
            </v-skeleton-loader>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
import { clone } from "lodash";
export default {
  data: () => ({
    saving: false,
    loading: false,
    form: {
      Title: "",
      Comment: "",
      Category: {},
      CreatedByUser: {},
      IDLabels: [],
      Labels: [],
      AssignedUserID: "",
      AssignedUser: {}
    },
    discussion: {
      Title: "",
      Comment: "",
      IDCategory: "",
      Category: {},
      CreatedByUser: {},
      IDLabels: [],
      Labels: [],
      Status: ""
    },
    ulasan: {
      IDDiscussion: "",
      Review: 0,
      ReviewComment: ""
    },
    replies: {},
    isEditingKategori: false,
    isEditingLabel: false,
    isEditingStatus: false,
    isEditingDelegasi: false,
    setStatusLoading: false,
    setKategoriLoading: false,
    setLabelLoading: false,
    setDelegasiLoading: false
  }),
  computed: {
    ...mapState({
      app: state => state.app,
      list: state => state.list
    }),
    ...mapGetters("list", [
      "isLabelLoading",
      "isKategoriLoading",
      "isDelegasiLoading"
    ]),
    isKategoriEmpty() {
      return this.$util.isEmpty(this.form.Category);
    },
    isLabelEmpty() {
      return this.$util.isEmpty(this.form.Labels);
    },
    isStatusEmpty() {
      return this.$util.isEmpty(this.form.Status);
    },
    isDelegasiEmpty() {
      return this.$util.isEmpty(this.form.AssignedUser);
    },
    isNew() {
      return !this.$route.params.id;
    },
    user() {
      return this.$session.get.user();
    },
    paramID() {
      return this.$route.params.id;
    },
    terkunci() {
      return (
        this.discussion.Status == "closed" ||
        this.discussion.Status == "verified"
      );
    },
    discussionStatusList() {
      if (this.$acl.not.check("isKepalaSpitda")) {
        return this.list.discussionStatus.filter(d => d.value != "verified");
      } else {
        return this.list.discussionStatus;
      }
    },
    userList() {
      let delegasiList = this.list.delegasi.data;
      if (delegasiList.length > 0 && this.form.AssignedIDUser) {
        let checkDelegasi = delegasiList.filter(
          d => d.ID == this.form.AssignedIDUser
        );
        if (checkDelegasi.length <= 0) {
          delegasiList.push(this.form.AssignedUser);
        }
        return delegasiList;
      } else {
        return delegasiList;
      }
    },
    bukaFormRating() {
      return (
        this.user.id == this.discussion.CreatedByUser.ID &&
        this.discussion.Status == "verified" &&
        this.discussion.Review == 0
      );
    }
  },
  methods: {
    ...mapActions("list", [
      "refreshLabel",
      "refreshKategori",
      "refreshDelegasi"
    ]),
    async send() {
      let discussionValid = true;
      let reviewValid = true;
      let categoriValid = true;

      if (this.$refs.discussion) {
        discussionValid = await this.$refs.discussion.validate();
      }
      if (this.$refs.kategori) {
        categoriValid = await this.$refs.kategori.validate();
      }
      if (this.$refs.reviews) {
        reviewValid = await this.$refs.reviews.validate();
      }

      if (!discussionValid || !categoriValid || !reviewValid) return;

      const confirmation = await this.$dialog.confirm({
        text: "Apakah anda yakin menyimpan data?"
      });
      if (!confirmation) return;

      let param = this.form;

      var user = this.$session.get.user();
      if (this.$acl.check("isSekolah") && user.idSekolah) {
        param.IDSekolah = user.idSekolah;
      }

      let url = "/discussion";
      if (!this.isNew) {
        param.ID = "";
        param.IDParentDiscussion = this.$route.params.id;
        param.CreatedBy = "";
        param.TotalReplies = 0;
        url = "/discussion/reply";
      } else {
        param.AssignedUser = null;
      }
      if (this.bukaFormRating) {
        url = "discussion/save/review";
        param = this.ulasan;
        param.IDDiscussion = this.$route.params.id;
      }
      this.saving = true;
      this.$axios
        .post(url, param)
        .then(res => {
          this.$dialog.notify.success(res.data.Message, {
            ...this.app.notification
          });

          let newID = res.data.Data.ID;
          if (this.isNew)
            this.$router.push(
              `/konseling/${res.data.Data.ID}`,
              () => this.refresh(newID),
              () => this.refresh(newID)
            );
          else this.refresh(this.$route.params.id);
        })
        .catch(error => {
          this.$dialog.notify.error(error, {
            ...this.app.notification
          });
        })
        .finally(() => {
          this.checkEditingStatus();
          this.saving = false;
        });
    },
    refresh(
      id,
      options = {
        onSuccess: () => {},
        onError: () => {},
        onFinally: () => {}
      }
    ) {
      this.$axios
        .get(`/discussion/${id}`)
        .then(res => {
          if (typeof options.onSuccess == "function") options.onSuccess();
          this.form = Object.assign(clone({ ...this.form, ...res.data.Data }), {
            Comment: "",
            Title: ""
          });

          this.discussion = clone({ ...this.form, ...res.data.Data });

          let replies = {};
          this.discussion.Replies.forEach(d => {
            replies[d.ID] = d;
          });
          this.replies = replies;
        })
        .catch(error => {
          if (typeof options.onError == "function") options.onError();
          this.$dialog.notify.error(error, {
            position: this.app.notification.position
          });
        })
        .finally(() => {
          if (typeof options.onFinally == "function") options.onFinally();
          this.checkEditingStatus();
        });
    },
    refreshWithLoading(id) {
      this.loading = true;
      this.refresh(id, {
        onFinally: () => {
          this.loading = false;
        }
      });
    },
    setStatus() {
      if (!this.isNew) {
        this.setStatusLoading = true;
        this.$axios
          .post("/discussion/set/status", {
            IDDiscussion: this.$route.params.id,
            Status: this.form.Status
          })
          .then(res => {
            this.$dialog.notify.success(res.data.Message, {
              ...this.app.notification
            });

            this.form = Object.assign(
              clone({ ...this.form, ...res.data.Data }),
              {
                Comment: "",
                Title: ""
              }
            );

            this.discussion = Object.assign(this.discussion, {
              Status: res.data.Data.Status
            });
            this.refresh(this.$route.params.id);
          })
          .catch(error => {
            this.form.Status = this.discussion.Status;
            this.$dialog.notify.error(error, {
              ...this.app.notification
            });
          })
          .finally(() => {
            this.checkEditingStatus();
            this.setStatusLoading = false;
          });
      } else {
        this.isEditingStatus = !this.isEditingStatus;
      }
    },
    setLabel() {
      if (!this.isNew) {
        this.setLabelLoading = true;

        this.$axios
          .post("/discussion/set/label", {
            IDDiscussion: this.$route.params.id,
            IDLabels: this.form.IDLabels
          })
          .then(res => {
            this.$dialog.notify.success(res.data.Message, {
              ...this.app.notification
            });

            this.form = Object.assign(
              clone({ ...this.form, ...res.data.Data }),
              {
                Comment: "",
                Title: ""
              }
            );
            this.refresh(this.$route.params.id);
          })
          .catch(error => {
            this.form.IDLabels = this.discussion.IDLabels;
            this.form.Labels = this.discussion.Labels;
            this.$dialog.notify.error(error, {
              ...this.app.notification
            });
          })
          .finally(() => {
            this.checkEditingStatus();
            this.setLabelLoading = false;
          });
      } else {
        this.isEditingLabel = !this.isEditingLabel;
      }
    },
    setKategori() {
      if (!this.isNew) {
        this.setKategoriLoading = true;
        this.$axios
          .post("/discussion/set/category", {
            IDDiscussion: this.$route.params.id,
            IDCategory: this.form.IDCategory
          })
          .then(res => {
            this.$dialog.notify.success(res.data.Message, {
              ...this.app.notification
            });

            this.form = Object.assign(
              clone({ ...this.form, ...res.data.Data }),
              {
                Comment: "",
                Title: ""
              }
            );

            this.refresh(this.$route.params.id);
          })
          .catch(error => {
            this.form.IDCategory = this.discussion.IDCategory;
            this.form.Category = this.discussion.Category;
            this.$dialog.notify.error(error, {
              ...this.app.notification
            });
          })
          .finally(() => {
            this.checkEditingStatus();
            this.setKategoriLoading = false;
          });
      } else {
        this.isEditingKategori = !this.isEditingKategori;
      }
    },
    setDelegasi() {
      if (!this.isNew) {
        this.setDelegasiLoading = true;
        this.$axios
          .post("/discussion/set/assignment", {
            IDDiscussion: this.$route.params.id,
            AssignedUserID: this.form.AssignedUserID,
            Escalated: this.$acl.not.check("isKepalaSpitda") ? true : false
          })
          .then(res => {
            this.$dialog.notify.success(res.data.Message, {
              ...this.app.notification
            });

            this.form = Object.assign(
              clone({ ...this.form, ...res.data.Data }),
              {
                Comment: "",
                Title: ""
              }
            );

            this.refresh(this.$route.params.id);
          })
          .catch(error => {
            this.form.AssignedUserID = this.discussion.AssignedUserID;
            this.form.AssignedUser = this.discussion.AssignedUser;
            this.$dialog.notify.error(error, {
              ...this.app.notification
            });
          })
          .finally(() => {
            this.checkEditingStatus();
            this.setDelegasiLoading = false;
          });
      } else {
        this.isEditingDelegasi = !this.isEditingDelegasi;
      }
    },
    removeLabel(item) {
      const index = this.form.Labels.findIndex(x => x.ID == item.ID);
      if (index > -1) this.form.Labels.splice(index, 1);
    },
    reset() {
      this.$refs.discussion.reset();
    },
    checkEditingStatus() {
      this.isEditingKategori = this.isKategoriEmpty;
      this.isEditingLabel = this.isLabelEmpty;
      this.isEditingStatus = this.isStatusEmpty;
      this.isEditingDelegasi = this.isDelegasiEmpty;
    },
    title() {
      return this.$route.params.id ? "Ubah Bidang" : "Bidang Baru";
    },
    parseStatus(status, item = "label") {
      let mapStatus = {
        open: {
          color: "info",
          icon: "mdi-help-circle-outline",
          label: `Terbuka`
        },
        reopen: {
          color: "info",
          icon: "mdi-help-circle",
          label: `Dibuka Kembali`
        },
        closed: {
          color: "secondary",
          icon: "mdi-lock-outline",
          label: `Tertutup`
        },
        verified: {
          color: "success",
          icon: "mdi-check-circle",
          label: `Terverifikasi`
        }
      };
      return mapStatus[status][item];
    }
  },
  async created() {
    this.refreshKategori();
    this.refreshLabel();
    this.refreshDelegasi({ UserID: this.user.id });
  },
  async mounted() {
    let id = this.$route.params.id;
    if (id) {
      this.loading = true;
      this.refresh(id, {
        onFinally: () => {
          this.loading = false;
        },
        onError: () => {
          this.$router.push("/konseling");
        }
      });
    } else {
      this.checkEditingStatus();
    }
  },
  watch: {
    "form.Labels"(v) {
      this.form.IDLabels = [];
      for (let i in v) {
        this.form.IDLabels.push(v[i].ID);
      }
    },
    "form.Category"(v) {
      if (v) this.form.IDCategory = v.ID;
    },
    "form.AssignedUser"(v) {
      if (v) this.form.AssignedUserID = v.ID;
    }
  }
};
</script>

<style>
</style>